export type EaseCurveId =
  | 'easeInOutCubic'
  | 'easeInOutQuad'
  | 'easeInOutSine'
  | 'easeOutQuad'
  | 'easeOutCubic'
  | 'linear';

const DEFAULT_CURVE: EaseCurveId = 'linear';

export function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
}

function easeInOutQuad(t: number): number {
  return t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
}

function easeInOutSine(t: number): number {
  return (1 - Math.cos(Math.PI * t)) / 2;
}

function easeOutQuad(t: number): number {
  return 1 - (1 - t) * (1 - t);
}

function easeOutCubic(t: number): number {
  return 1 - (1 - t) ** 3;
}

function linear(t: number): number {
  return t;
}

const EASE_BY_ID: Record<EaseCurveId, (t: number) => number> = {
  easeInOutCubic,
  easeInOutQuad,
  easeInOutSine,
  easeOutQuad,
  easeOutCubic,
  linear
};

export function applyEaseCurve(t: number, curve: string | undefined): number {
  const fn = curve && curve in EASE_BY_ID ? EASE_BY_ID[curve as EaseCurveId] : EASE_BY_ID[DEFAULT_CURVE];
  return fn(t);
}
